@use "~theme/breakpoints";

.headerSkeleton {
  height: 72px;
  display: flex;
  align-items: center;
  padding: 24px var(--mobile-gutter);
  border-bottom: 1px solid var(--blue-01-at-30);
}

.instructionSkeleton {
  padding: 32px var(--mobile-gutter) 32px calc(var(--mobile-gutter) + 28px);
}

.instructionSkeletonInner {
  position: relative;
}

.addToCalendarButtonSkeleton {
  display: none;

  @include breakpoints.desktop {
    display: block;
    position: absolute;
    margin-top: 0;
    top: 0;
    right: 0;
    line-height: 0;
  }
}
